
import { injectable } from "inversify";
import { IHashingService } from "../interfaces/hashingService";

@injectable()
class HashingService implements IHashingService {

    // create SHA-256 hash
    public async createHash(text: string){
        try {
            const encoder = new TextEncoder(); 
            const data = encoder.encode(text); 
            const hashBuffer = await crypto.subtle.digest('SHA-256', data);
            const hashArray = Array.from(new Uint8Array(hashBuffer)); 
            const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); 
            
            return hashHex;
        }
        catch (e) {
            console.log(e);
        }
    }
}

export { HashingService }